import logo from './logo.svg';
import './App.css';
import './HomeScreen.css';
import React from 'react';
import { Button,Page,Grids,Flex,FlexItem,   Footer,
    FooterText,
    FooterLinks,
    FooterLink,NavLink,InfiniteLoader, ButtonArea, Tab, TabBar, TabBarItem} from 'react-weui';
import 'weui';
import { useState } from 'react';
import 'react-weui/build/packages/react-weui.css';
import HomeGrid from './HomeGrid';
import axios from 'axios';
import ProductList from "./ProductList";
import GlobalTools from "./utils/GlobalTools";
import withRouter from "./withRouter"


class HomeScreen extends React.Component {

    constructor(props) {
        super(props);
        console.log("构造器初始化");
        console.log(this);
        var that  = this ;
        GlobalTools.autoU(this.props.router.location.search,function(context){
            console.log("得到U:"+context.u);
            that.state = { 
                leftProducts:[],
                rightProducts:[],
                rawProducts:[],
                leftHeight:0,
                rightHeight:0,
                page:1,
                filter:"所有",
                u:context.u,
                searchText: '',
                isFlowBuilding:false
            }

            //console.log("构造器中修复url");
            //GlobalTools.fixUrl(context.u);
        });

        

        this.onLoadMore = this.onLoadMore.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
        this.handleSearchKeyPress = this.handleSearchKeyPress.bind(this);
    };

    
    componentWillMount(){

     }

    componentDidMount(){
        //确保使用https
        GlobalTools.fixHttps(); 
        GlobalTools.fixUrl(this.state.u);
        //初始化
        this.initProductList();
    }

    async initProductList(){
        console.log("初始化产品列表");
        var that = this;
        that.setState({ isLoading: true });
        await axios.get( `/hopeapi/product/full` )
        .then( function (response) {
            console.log("request done");
            //console.log(response);
            if (response.data.status && response.data.data && response.data.data.length > 0) {
                const rawProducts = response.data.data || []
                that.setState({rawProducts:rawProducts, page:1,isFlowBuilding:true});
            
                let displayProductList =[];
                if( rawProducts.length>=20){
                    displayProductList = rawProducts.slice(0,20);
                }else{
                    displayProductList = rawProducts;
                }
                
                that.buildDisplayProductList(displayProductList,that,[],[]);
            }
        }).finally(function(){
            that.setState({ isLoading: false });
        });
      
    }

    searchFilter(dataArry,keywords){
        if(keywords){
            //对产品进行过滤
            var filterDataArray = dataArry.filter((x)=>{

                return x.productTitle.indexOf(keywords)>-1 || x.productContent.indexOf(keywords)>-1;
            })
            console.log("有搜索词，直接符合条件的卡种");
            console.log(filterDataArray);
            return filterDataArray;
        }

        console.log("无搜索词，直接返回原始数据");
        console.log(dataArry);
        return dataArry;
    }

    //运营商切换
    productsFilter(dataArry,targetFitler){

        if(targetFitler === "所有"){

            return  dataArry;
        }

        console.log("需要过滤产品");
        //对产品进行过滤
        var filterDataArray = dataArry.filter((x)=>{

            return x.productTitle.indexOf(targetFitler)>-1 || x.productContent.indexOf(targetFitler)>-1;
        })

        return filterDataArray;
    }

    async buildDisplayProductList(dataArry,that,leftProducts,rightProducts){
    

        console.log("进入buildDisplayProductList渲染");
        console.log(that.state);
        console.log(dataArry);

        for (const item of dataArry.values()) {
                    
                    //console.log(item);
                    if (that.state.leftHeight <=  that.state.rightHeight) {
                        //console.log("right");
                        leftProducts.push(item)
                    } else {
                        //console.log("right");
                        rightProducts.push(item)
                    }
                    
                    //更新两边的高度
                    await  ((context,leftList, rightList)=>{
                        return new Promise((resolve) => {
                            context.setState({
                                leftProducts,
                                rightProducts
                            }, () => {
                                //统计高度 左侧
                                var leftItemDoms = document.querySelectorAll('#leftList .pro-item');
                                var calLeftHeight= 0;
                                leftItemDoms.forEach(item=>{
                                    //console.log(item);
                                    let  leftQuery = item.getBoundingClientRect();
                                    calLeftHeight =calLeftHeight+leftQuery.height;
                                });


                                //统计高度 右侧
                                var rightItemDoms = document.querySelectorAll('#rightList .pro-item');
                                var calRightHeight= 0;
                              
                                rightItemDoms.forEach(item=>{
                                    //console.log(item);
                                    let  rightQuery = item.getBoundingClientRect();
                                    calRightHeight = calRightHeight + rightQuery.height;
                                });

                                context.setState({
                                    leftHeight:calLeftHeight,
                                    rightHeight:calRightHeight

                                });

                                //console.log("calLeftHeight:"+calLeftHeight);
                                //console.log("rightHeight:"+calRightHeight);
                                resolve();
                            })
                        })
                      })(that,leftProducts, rightProducts);
       }  

       that.setState({ isFlowBuilding:false});
    }

    onLoadMore = (resolve, finish) => {
        console.log("加载更多列表");
        let {page,isFlowBuilding,rawProducts,leftProducts,rightProducts} = this.state;
        var that  = this;

        // 运营商过滤+搜索功能
        let productsPreDeal = that.productsFilter(rawProducts,that.state.filter);
        let searchProducts = that.searchFilter(productsPreDeal,that.state.searchText);

 
        if(isFlowBuilding){
            console.log("正在构建瀑布，先返回");
            resolve();
            return;
          }

          console.log("page",page);
          console.log("searchProducts.length",searchProducts.length);
          console.log("pageSize",searchProducts.length/20);
          

          //如果已经没有数据了，就不要执行后续
        if(page*20>searchProducts.length){
            console.log("已经到底了");
            //finish();
            resolve();
            return;
        }

          //到这里，说明还有数据，让我们取出数据
         let displayProductList = [];
         if(searchProducts.length>=20*(page+1)){
            console.log("加载一页，还有更多数据");
            displayProductList=searchProducts.slice(20*page,20*page+20);
            that.setState({ page:page+1 , isFlowBuilding:true });  
            that.buildDisplayProductList(displayProductList,that,leftProducts,rightProducts);
            resolve();
          }else{
            console.log("只够加载一次了");
            displayProductList=searchProducts.slice(20*page,rawProducts.length);
            that.setState({ page:page+1 , isFlowBuilding:true });  
            that.buildDisplayProductList(displayProductList,that,leftProducts,rightProducts);
            //finish();
            resolve();
 
          }
    };

    onFilterChange = (e)=>{
        var that = this;
        let {rawProducts,filter,searchText} = this.state;
        console.log(e);
        //重复点击忽略
        if(this.state.filter===e.target.textContent){
            return ;
        }

        console.log(e.target.textContent);

        // 运营商过滤+搜索功能
        let productsPreDeal = that.productsFilter(rawProducts, e.target.textContent);
        let searchProducts = that.searchFilter(productsPreDeal, searchText);

        that.setState({
            page:1,
            isFlowBuilding:true, 
            leftProducts:[],
            rightProducts:[],
            leftHeight:0,
            rightHeight:0,
            filter:e.target.textContent
           });
            
        let displayProductList =[];
        if( searchProducts.length>=20){
            displayProductList = searchProducts.slice(0,20);
        }else{
            displayProductList = searchProducts;
        }
        
        that.buildDisplayProductList(displayProductList,that,[],[]);
        
    }

    handleSearchKeyPress(e) {
        if (e.key === 'Enter') {
            this.handleSearch();
        }
    }

    handleSearchInputChange(e) {
        this.setState({ searchText: e.target.value });
    }

    handleSearch() {
        console.log('用户点击了搜索');
        let that = this;
        let {rawProducts,filter,searchText} = this.state;

        // 运营商过滤+搜索功能
        let productsPreDeal = that.productsFilter(rawProducts, filter);
        let searchProducts = that.searchFilter(productsPreDeal, searchText);

        that.setState({
            page:1,
            isFlowBuilding:true, 
            leftProducts:[],
            rightProducts:[],
            leftHeight:0,
            rightHeight:0
           });
            
        let displayProductList =[];
        if( searchProducts.length>=20){
            displayProductList = searchProducts.slice(0,20);
        }else{
            displayProductList = searchProducts;
        }
        
        console.log("开始显示数据");
        console.log(displayProductList)
        that.buildDisplayProductList(displayProductList,that,[],[]);
    }

    render() {
        var that = this;
        let {filter,u,searchText,isLoading} = this.state;
        const tabList = ["所有", "联通", "电信", "移动", "广电"];
        return (
            <Page  className="infinite" title="号码宝" subTitle="联通电信移动广电优惠套餐办理" infiniteLoader={true}
             onLoadMore={(resolve, finish) => this.onLoadMore(resolve, finish)} ptr={false}  >

             <HomeGrid u={u}/>

             <div style={{ display: 'flex', alignItems: 'center', margin: '10px 0', padding: '0 10px' }}>
                <input
                    type="text"
                    value={searchText}
                    onChange={this.handleSearchInputChange}
                    onKeyDown={this.handleSearchKeyPress}
                    placeholder="请输入搜索内容"
                    style={{ flex: 1, height: '32px', fontSize: '16px', padding: '0 8px', border: '1px solid #ccc', borderRadius: '4px' }}
                />
                <Button
                    size="small"
                    type="primary"
                    style={{ marginLeft: '8px', height: '32px', lineHeight: '32px' }}
                    onClick={this.handleSearch}
                >
                    搜索
                </Button>
            </div>

            {/* 横向可滑动按钮组替换ButtonArea */}
            <div style={{overflowX: 'auto', whiteSpace: 'nowrap', padding: '0 10px', marginBottom: 0, display: 'flex', justifyContent: 'center'}}>
                <div style={{display: 'inline-block'}}>
                    {tabList.map(tab => (
                        <button
                            key={tab}
                            onClick={e => this.onFilterChange({ target: { textContent: tab } })}
                            style={{
                                display: 'inline-block',
                                minWidth: 60,
                                padding: '6px 12px',
                                marginRight: 6,
                                border: 'none',
                                borderRadius: 12,
                                background: filter === tab ? '#1aad19' : '#f5f5f5',
                                color: filter === tab ? '#fff' : '#333',
                                fontWeight: filter === tab ? 'bold' : 'normal',
                                fontSize: 16,
                                cursor: 'pointer',
                                outline: 'none',
                                transition: 'background 0.2s'
                            }}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
            </div>
           
             {isLoading ? (
                <div style={{textAlign:'center',padding:'30px 0',fontSize:'18px'}}>稍后，正在加载数据...</div>
            ) : (
                <Flex >
                    <FlexItem className="pro-box-left" id="leftList">
                        <ProductList products={ that.state.leftProducts}  u={u}></ProductList>
                    </FlexItem>
                    <FlexItem className="pro-box-right" id="rightList">
                        <ProductList products={ that.state.rightProducts} u={u}></ProductList>
                    </FlexItem>
                </Flex>
            )}

             <Footer>
                <FooterLinks>
                    <FooterLink href="https://www.10055.net">号码宝</FooterLink>
                    <FooterLink href="https://beian.miit.gov.cn/">京ICP备15052719号-9</FooterLink>
                    <FooterLink href="https://beian.miit.gov.cn/">京ICP备15052719号-7</FooterLink>
                    <FooterLink href="https://beian.miit.gov.cn/">京ICP备15052719号-12</FooterLink>
                </FooterLinks>
                <FooterText>Copyright &copy; 2015-2029 www.10055.net</FooterText>
            </Footer>
           
         </Page>
       );
    }

}


export default withRouter(HomeScreen) ;